<template>
  <section class="tkn-body" id="tkn-body" ref="question_bus">
    <a-back-top :target="target">
      <div class="back-top">
        <img src="./../assets/images/back_top.png" alt="" />
      </div>
    </a-back-top>
    <top-menu @subject="subject" :noPick="noPick" :showSubject="showSubject"></top-menu>
    <div class="bus-container" :class="{ isFixed: titleFixed, haveScrollBar: haveScrollBar }">
      <slot name="bus"></slot>
    </div>
    <div class="tkn-body__wrap">
      <Breadcrumb v-if="breadcrumb"></Breadcrumb>
      <div class="tkn-content">
        <slot></slot>
      </div>
    </div>
    <div class="tkn-footer">
      <Footer></Footer>
    </div>
    <pay-qrcode :data="list"></pay-qrcode>
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import TopMenu from '@/components/TopMenu.vue'
import PayQrcode from './common/payments/PayQrcode.vue'
import Breadcrumb from '@/components/common/breadcrumb/Breadcrumb.vue'
import { throttle, debounce } from 'throttle-debounce'
import { skuList } from './common/payments/types/api'

export default {
  name: 'mainTemplate',
  props: {
    msg: String,
    noPick: Boolean,
    showSubject: {
      default() {
        return true
      },
      type: Boolean
    },
    breadcrumb: {
      default() {
        return true
      },
      type: Boolean
    }
  },
  mounted() {
    this.titleFixed = false
    window.addEventListener('scroll', throttle(20, this.handleScroll), true)
    this.getSkuList()
  },
  data() {
    return {
      titleFixed: false,
      list: [],
      haveScrollBar: false
    }
  },
  watch: {
    user: {
      handler(val, old) {
        if (val && val.name) {
          this.getSkuList()
        }
      },
      deep: true
    }
  },
  components: { TopMenu, Footer, Breadcrumb, PayQrcode },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    subject(val) {
      // console.log(val)
    },
    target() {
      return document.getElementById('app')
    },
    handleScroll() {
      let offsetTop =
        this.$refs.question_bus.getBoundingClientRect &&
        this.$refs.question_bus.getBoundingClientRect().top
      let element = document.getElementById('app')
      let offsetWidth = element.offsetWidth
      let clientwidth = element.clientWidth
      this.titleFixed = offsetTop < -78
      if (offsetWidth - clientwidth > 0 && this.titleFixed) {
        this.haveScrollBar = true
      } else {
        this.haveScrollBar = false
      }
    },
    async getSkuList() {
      let { data } = await skuList({
        sku_type: 'membership'
      })
      this.list = data
    }
  }
}
</script>
<style scoped lang="scss">
.back-top {
  width: 64px;
  height: 64px;
  line-height: 58px;
  background: rgba(255, 255, 255, 1);
  text-align: center;
  font-size: 32px;
}
.isFixed {
  position: fixed !important;
  top: 0px !important;
}
.bus-container {
  position: absolute;
  right: 0;
  top: 78px;
  z-index: 50;
}
#tkn-body .ant-back-top {
  right: 48px;
  bottom: 112px;
}
.haveScrollBar {
  right: 15px !important;
}
.tkn-body {
  min-width: 1270px;
}
@media screen and (max-width: 1366px) {
  .bus-container {
    top: 62px;
  }
  .back-top {
    width: 48px;
    height: 48px;
    line-height: 40px;
    font-size: 24px;
    img {
      width: 28px;
    }
  }
  #tkn-body .ant-back-top {
    right: 48px;
    bottom: 112px;
  }
}
@media screen and (max-width: 1199px) {
  .back-top {
    width: 40px;
    height: 40px;
    line-height: 36px;
    font-size: 24px;
    img {
      width: 28px;
    }
  }
  #tkn-body .ant-back-top {
    right: 30px;
    bottom: 100px;
  }
}
@media screen and (max-width: 1023px) {
  .back-top {
    width: 36px;
    height: 36px;
    line-height: 30px;
    font-size: 24px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    img {
      width: 24px;
    }
  }
  #tkn-body .ant-back-top {
    right: 20px;
    bottom: 100px;
  }
}
.tkn-body {
  min-height: 100%;
}
</style>
